import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import "antd/dist/antd.css";

import Router from "./router";
import i18n from "./translation";
import { initAnalytics } from "./services/analytics";

initAnalytics();

const App = () => (
  <BrowserRouter>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
    </HelmetProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById("root"));
